<qaroni-status-preview
  [status]="status() | projectsStatus"
  [bgColorClass]="bgColorClass" />
